import { registerCondition } from 'core/forms';

const isHtmlEditorChecked = ({ model }) => ({
  condition: null,
  hasCondition: Boolean(model.is_html),
});

registerCondition('isHtmlEditorChecked', isHtmlEditorChecked);

export default isHtmlEditorChecked;
